import { defineStyle, defineStyleConfig } from '@chakra-ui/react';
import getThemes, { ThemesKeys } from '../shared/themeShared';

const disabledRevoo = (theme: ThemesKeys) => ({
  color: getThemes(theme).colors.palette.text.secondary[80],
  opacity: 1,
  cursor: 'not-allowed',
  boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.stroke.secondary[90]}`,
  bg: getThemes(theme).colors.palette.primary[95],
  border: 0,
  _hover: {
    border: 0,
    boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.stroke.secondary[90]}`,
  },
  _placeholder: {
    color: getThemes(theme).colors.palette.text.secondary[60],
  },
});

const baseStyle = (theme: ThemesKeys) =>
  defineStyle({
    borderRadius: getThemes(theme).radii.lg,
    boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.stroke.primary[80]}`,
    _hover: {
      boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.primary[50]}`,
    },
    _focus: {
      boxShadow: `0 0 0 2px ${getThemes(theme).colors.palette.primary[50]}`,
    },
    '&.textarea:not(:disabled)': {
      bg: 'white',
      border: 0,
      _focusVisible: {
        boxShadow: `0 0 0 2px ${getThemes(theme).colors.palette.primary[50]}`,
      },
    },
    _placeholder: {
      color: getThemes(theme).colors.palette.text.secondary[60],
    },
    _disabled: disabledRevoo(theme),
  });

export const textareaTheme = (theme: ThemesKeys) =>
  defineStyleConfig({
    baseStyle: baseStyle(theme),
  });

export default (theme: ThemesKeys) => textareaTheme(theme);
